import { useCallback, useState } from 'react';

export const useAudioPlayer = ({ player, length }) => {
    const [ activeTrack, setActiveTrack ] = useState(0);
    const [ isPlaying, setIsPlaying ] = useState(false);
    const [ showPlayer, setShowPlayer ] = useState(false);

    const nextTrack = useCallback(() => {
        if (activeTrack < (length - 1)) {
            setActiveTrack((oldTrack) => oldTrack + 1)
        } else {
            setActiveTrack(0)
        }
    }, [ activeTrack, length ]);

    const prevTrack = useCallback(() => {
        if (activeTrack > 0) {
            setActiveTrack((oldTrack) => oldTrack - 1)
        } else {
            setActiveTrack(length - 1);
        }
    }, [ activeTrack, length ]);

    const onTrackClick = useCallback((index) => (e)=> {
        if (index === activeTrack) {
            player?.current?.togglePlay(e)
        } else {
            setActiveTrack(index);
        }
    }, [activeTrack]);

    const onPlay = useCallback(() => {
        setIsPlaying(true);
        setShowPlayer(true)
    }, []);

    const onPause = useCallback(() => {
        setIsPlaying(false);
    }, []);

    return {
        activeTrack,
        onPlay,
        onPause,
        onClickNext: nextTrack,
        onClickPrevious: prevTrack,
        onTrackClick,
        isPlaying,
        showPlayer
    }
}
